import { Camera, Upload } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';

interface ParkingLotSetupPlaceholderProps {
  canEdit: boolean;
  onUpload: () => void;
}

export function ParkingLotSetupPlaceholder({
  canEdit,
  onUpload,
}: ParkingLotSetupPlaceholderProps) {
  return (
    <Card className="border-dashed border-2 bg-muted/20">
      <CardContent className="flex flex-col items-center justify-center py-16 text-center">
        <div className="rounded-full bg-muted p-6 mb-6">
          <Camera className="h-12 w-12 text-muted-foreground" />
        </div>
        
        <h3 className="text-xl font-semibold mb-2">
          Set Up Parking Lot Map
        </h3>
        
        <p className="text-muted-foreground max-w-md mb-6">
          OptiBay requires a clear, shop-approved aerial image to enable precision 
          parking lot mapping. Upload a drone or overhead photo of your lot to get started.
        </p>
        
        {canEdit ? (
          <Button onClick={onUpload} size="lg" className="gap-2">
            <Upload className="h-5 w-5" />
            Upload Parking Lot Image
          </Button>
        ) : (
          <p className="text-sm text-muted-foreground italic">
            Contact a manager to set up the parking lot map.
          </p>
        )}
        
        <div className="mt-8 text-sm text-muted-foreground space-y-1">
          <p>Recommended: Drone photo or high-resolution overhead image</p>
          <p>Minimum resolution: 3000 × 2000 pixels</p>
          <p>Supported formats: JPG, PNG</p>
        </div>
      </CardContent>
    </Card>
  );
}
